// extracted by mini-css-extract-plugin
export default {"menu__items":"Menu_menu__items__cCwjL","menu__link":"Menu_menu__link__YgBGo"};